export const EXPIRING_SOON_DAYS = 14;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export enum ApiKeyStatus {
	Active = 'active',
	ExpiringSoon = 'expiringSoon',
	Expired = 'expired',
}

export interface ApiKeyStatusDisplay {
	label: string;
	// A subset of the Pill palette (keyof ThemeColors['pill']); semantic, distinct from the brand accent.
	color: 'green' | 'yellow' | 'red';
}

export const API_KEY_STATUS_DISPLAY: Record<ApiKeyStatus, ApiKeyStatusDisplay> = {
	[ApiKeyStatus.Active]: { label: 'Active', color: 'green' },
	[ApiKeyStatus.ExpiringSoon]: { label: 'Expiring soon', color: 'yellow' },
	[ApiKeyStatus.Expired]: { label: 'Expired', color: 'red' },
};

/**
 * Derives a key's display status from its expiration date. Keys with no expiration
 * are always Active. `now` is injectable for testing.
 */
export function deriveApiKeyStatus(expirationDate?: Date | string | null, now: Date = new Date()): ApiKeyStatus {
	if (!expirationDate) {
		return ApiKeyStatus.Active;
	}

	const expiry = new Date(expirationDate);
	if (Number.isNaN(expiry.getTime())) {
		return ApiKeyStatus.Active;
	}

	if (expiry.getTime() <= now.getTime()) {
		return ApiKeyStatus.Expired;
	}

	if (expiry.getTime() <= now.getTime() + EXPIRING_SOON_DAYS * MS_PER_DAY) {
		return ApiKeyStatus.ExpiringSoon;
	}

	return ApiKeyStatus.Active;
}
